// @ts-nocheck
import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Video, { VideoResource } from 'models/propTypes/video';
import { PlaybackTypes } from 'models/kitchenSink';
import {
  appendHLSEncryptionConfig,
  appendFullDRMConfig,
} from 'support/player/resourceHelper';
import { fetchJWTToken } from 'support/api/VideoApi';

const DRMProvider = ({ resource, video, onError, render }) => {
  const [res, setRes] = useState(null);
  const userPackage = useSelector(
    state => state.auth.paramountPlus.user.data?.userPackage,
  );
  const userId = useSelector(
    state => state.auth.paramountPlus.user.data?.userId,
  );
  const tokenUrl = useSelector(state => {
    if (video?.playback?.type === PlaybackTypes.HLS_ENCRYPTION) {
      return state.kitchenSink.data.playback?.[PlaybackTypes.HLS_ENCRYPTION]
        .tokenUrl;
    }
    if (video?.playback?.type === PlaybackTypes.FULL_DRM) {
      return state.kitchenSink.data.playback?.[PlaybackTypes.FULL_DRM].tokenUrl;
    }
    if (video?.playback?.type === PlaybackTypes.STATION_OPT_IN) {
      return state.kitchenSink.data.playback?.[PlaybackTypes.STATION_OPT_IN]
        ?.tokenUrl;
    }
    return '';
  });
  const widevineUrl = useSelector(
    state => state.kitchenSink.data.playback?.[PlaybackTypes.FULL_DRM].widevine,
  );
  const playreadyUrl = useSelector(
    state =>
      state.kitchenSink.data.playback?.[PlaybackTypes.FULL_DRM].playready,
  );

  const context = useRef();
  useEffect(() => {
    context.current = {
      video,
      userPackage,
      userId,
      tokenUrl,
      onError,
      widevineUrl,
      playreadyUrl,
    };
  });

  useEffect(() => {
    const {
      video: vid,
      userPackage: packageCode,
      userId: id,
      tokenUrl: url,
      onError: onErr,
      widevineUrl: wvUrl,
      playreadyUrl: prUrl,
    } = context.current;
    if (
      resource &&
      vid &&
      (vid.playback.type === PlaybackTypes.HLS_ENCRYPTION ||
        vid.playback.type === PlaybackTypes.FULL_DRM ||
        vid.playback.type === PlaybackTypes.STATION_OPT_IN)
    ) {
      fetchJWTToken(url, id, packageCode)
        .then(token => {
          if (
            vid.playback.type === PlaybackTypes.HLS_ENCRYPTION ||
            vid.playback.type === PlaybackTypes.STATION_OPT_IN
          ) {
            setRes(appendHLSEncryptionConfig({ ...resource }, token));
          } else if (vid.playback.type === PlaybackTypes.FULL_DRM) {
            setRes(
              appendFullDRMConfig(
                { ...resource },
                token,
                vid.viacomContentId,
                wvUrl,
                prUrl,
              ),
            );
          }
        })
        .catch(() => {
          // do nothing
          onErr({ type: 'DRM' });
        });
    } else {
      setRes(resource);
    }
  }, [resource]);

  return render({ resource: res });
};

DRMProvider.propTypes = {
  resource: VideoResource,
  video: Video,
  onError: PropTypes.func,
  render: PropTypes.func.isRequired,
};

DRMProvider.defaultProps = {
  resource: null,
  video: null,
  onError: () => {},
};

export default DRMProvider;
